import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, Input } from 'reactstrap';
import reg from '../../util/Regex';
import './PopupDialog.css';

function PopupDialog(props) {

    const [email, setEmail] = useState('');
    const [inValidEmail, setInValidEmail] = useState(false);

    const handleModal = () => {
        props.handleModal();
    }

    const onSubmit = () => {
        if (isValidEmail(email)) {
            setInValidEmail(false);
            props.popupSubmit(email);
        } else {
            setInValidEmail(true);
        }
    }

    const isValidEmail = val => {
        if (!reg.emailValidation.test(val)) {
            return false;
        } else return true;
    }

    const { showModal, title, message, email: Email, confirmBtn, sessionTimeoutSubmit } = props;

    return (
        <div>
            {/* Modal starts */}
            <Modal isOpen={showModal} className="comment-box" >
                <ModalHeader className={`widgetHeaderColor ${!title ? "noBorder" : ""}`} toggle={handleModal}>
                    {title ? <span className="modal-title popup-title font-main darkcolor" id="siteModalLabel">{title}</span> : <span style={{ height: "410px" }}></span>}

                    <button onClick={handleModal} type="button" className="btn-close commentClose" data-bs-dismiss="modal" aria-label="Close"></button>
                </ModalHeader>
                <ModalBody className="reorderBody popup-body">
                    <div className={`text-center font-main ${Email ? 'mb-10' : 'mb-20'}`}>{message}</div>
                    {Email ? <>
                        <div>Enter your email:</div>
                        <div className="mb-20"> <Input
                            className="form-control"
                            type="text"
                            name="email"
                            id="email"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setInValidEmail(inValidEmail)
                            }}
                        />
                            {inValidEmail ? <div className="input-error">Invalid Email</div> : ''}
                        </div>

                    </> : <></>}
                    <div className="text-center">
                        {Email ? <>
                            <button onClick={onSubmit} className="btn-web mr-20"> OK </button>
                            <button onClick={handleModal} type="button" className="btn-darker"> Cancel </button> </> :

                            confirmBtn ? <>
                                <button onClick={() => sessionTimeoutSubmit('continue')} className="btn-web mr-20"> Continue working </button>
                                <button onClick={() => sessionTimeoutSubmit('logout')} type="button" className="btn-darker"> Logout </button> </> :

                                <button onClick={handleModal} className="btn-web"> OK </button>}
                    </div>
                </ModalBody>
            </Modal>
            {/* Modal ends */}
        </div>
    )
}

export default connect(null)(PopupDialog)